import { IconButton } from '@doordash/component-button'
import { AnchoredLayer } from '@doordash/component-layer-manager'
import * as React from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import * as events from '../../../events'
import * as DA from '../../../typeModules/events'
import Menu from './menu'
import { HamburgerContainer } from './styles'
import { ItemType } from './types'

type HamburgerProps = {
  itemList: ItemType[]
}

type ReduxProps = {
  trackLandingPageHeader: (data: DA.LandingPageHeader) => Promise<any>
}

const handleClick = (
  history,
  setShowingMenu: React.Dispatch<React.SetStateAction<boolean>>,
  trackLandingPageHeader: (data: DA.LandingPageHeader) => Promise<any>
) => (anchor: string, trackingId: DA.HeaderNames) => {
  history.push(`${history.location.search}${anchor}`)
  setShowingMenu(false)

  trackLandingPageHeader({
    action: DA.EventActions.Clicked,
    name: trackingId,
  })
}

const handleHamburgerClick = (
  setShowingMenu: React.Dispatch<React.SetStateAction<boolean>>,
  isShowingMenu: boolean,
  trackLandingPageHeader: (data: DA.LandingPageHeader) => Promise<any>
) => {
  setShowingMenu(!isShowingMenu)
  trackLandingPageHeader({
    action: DA.EventActions.Clicked,
    name: DA.HeaderNames.HamburgerButton,
  })
}

export const Hamburger: React.FC<HamburgerProps &
  RouteComponentProps &
  ReduxProps> = ({ itemList, history, trackLandingPageHeader }) => {
  const [isShowingMenu, setShowingMenu] = React.useState(false)
  return (
    <HamburgerContainer>
      <AnchoredLayer
        offset={[-AnchoredLayer.Offset.XSmall - 4, AnchoredLayer.Offset.XSmall]}
        position={AnchoredLayer.Positions.BottomLeft}
        content={
          isShowingMenu && (
            <Menu
              itemList={itemList}
              handleClick={handleClick(
                history,
                setShowingMenu,
                trackLandingPageHeader
              )}
            />
          )
        }
      >
        <IconButton
          size={IconButton.Sizes.Medium}
          accessibilityLabel="menu"
          iconType={IconButton.IconTypes.Menu}
          onClick={() =>
            handleHamburgerClick(
              setShowingMenu,
              isShowingMenu,
              trackLandingPageHeader
            )
          }
        />
      </AnchoredLayer>
    </HamburgerContainer>
  )
}

const mapDispatchToProps = {
  trackLandingPageHeader: events.trackLandingPageHeader,
}

export default connect(null, mapDispatchToProps)(withRouter(Hamburger))
